document.addEventListener('DOMContentLoaded', function () {

  const elements = [
    { suffix: '_3nAh9g', className: 'la-meva-classe' },
    { suffix: '_ar7ciz', className: 'section-slider' },
    { suffix: '_RTeKcT', className: 'section-hero-sota-slider' },
    { suffix: '_tEdyRG', className: 'section-hero-only-img' },
    { suffix: '_bxenPp', className: 'section-Title-Dark' },
    
    { suffix: '_W7eFhw', className: 'section-Content-Dark' },
    { suffix: '_krgmUe', className: 'section-Content-Dark' },
    { suffix: '_RBnWhL', className: 'section-Content-Dark' },

    { suffix: '_BLzp4G', className: 'header-button-principal' },
    { suffix: '_TGq3gD', className: 'header-button-secundari' },

    { suffix: '_fa6P9H', className: 'INN-HOME-product-list' },
    { suffix: '_MBV7V9', className: 'INN-HOME-doble-cta' },

    { suffix: '_dneVnN', className: 'hero-main-image-centered' }
  ];

  function queryNodes(suffix) {
    return document.querySelectorAll(
      '[id*="' + suffix + '"], [class*="' + suffix + '"]'
    );
  }

  function applyClasses() {
    elements.forEach(item => {
      const nodes = queryNodes(item.suffix);

      nodes.forEach(el => {
        if (!el.classList.contains(item.className)) {
          el.classList.add(item.className);
        }
      });
    });
  }

  applyClasses();

  const observer = new MutationObserver(applyClasses);
  observer.observe(document.documentElement, { childList: true, subtree: true });

});
